import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
// import socket from "../../assets/socketConnection";
import {
  setAlertPageClean,
  setAlertPageFirstBtnFunc,
  setAlertPageSecondBtnFunc,
  toggleAlertPageIsVisible,
} from "../../redux/alertPage/alertPage.actions";
// import { toggleAlertPageIsVisible } from "../../redux/alertPage/alertPage.actions";
import {
  selectAlertPageFirstBtn,
  selectAlertPageFirstBtnFunc,
  selectAlertPageIsVisible,
  selectAlertPageMessage,
  selectAlertPageSecondBtn,
} from "../../redux/alertPage/alertPage.selector";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
import { AlertPageStyled } from "./alertPage.styles";

const AlertPage = ({
  selectAlertPageIsVisible,
  selectAlertPageFirstBtn,
  selectAlertPageMessage,

  toggleAlertPageIsVisible,

  selectAlertPageSecondBtn,

  setAlertPageFirstBtnFunc,
  setAlertPageSecondBtnFunc,
  selectCurrentReqInfo,
  selectAlertPageFirstBtnFunc,

  setAlertPageClean,
}) => {
  useEffect(() => {
    // effect
    if (selectAlertPageIsVisible === false) {
      setTimeout(() => {
        setAlertPageClean();
      }, 1000);
    }
    // return () => {
    //   alert("bye");
    // };
  }, [selectAlertPageIsVisible, setAlertPageClean]);

  const handle_firstBtn_click = () => {
    if (selectAlertPageFirstBtnFunc) selectAlertPageFirstBtnFunc();
    // debugger;
    toggleAlertPageIsVisible();
  };
  const handle_secondBtn_click = () => {
    toggleAlertPageIsVisible();
  };

  return (
    <AlertPageStyled show={selectAlertPageIsVisible}>
      <div className="alert-page__inner">
        <div className="text-muted">{selectAlertPageMessage}</div>

        <div className="d-flex align-items-center justify-content-center w-100 flex-column mt-3">
          <button
            className="alert-page__btn btn"
            onClick={handle_firstBtn_click}
          >
            {selectAlertPageFirstBtn ? selectAlertPageFirstBtn : "باشه"}
          </button>
          <button
            className="alert-page__btn btn mt-2"
            onClick={handle_secondBtn_click}
          >
            {selectAlertPageSecondBtn ? selectAlertPageSecondBtn : "لغو"}
          </button>
        </div>
      </div>
    </AlertPageStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectAlertPageIsVisible: selectAlertPageIsVisible,

  selectAlertPageFirstBtn: selectAlertPageFirstBtn,
  selectAlertPageSecondBtn: selectAlertPageSecondBtn,
  selectAlertPageMessage: selectAlertPageMessage,

  selectCurrentReqInfo: selectCurrentReqInfo,
  selectAlertPageFirstBtnFunc: selectAlertPageFirstBtnFunc,
});

const mapDispatchToProps = (dispatch) => ({
  toggleAlertPageIsVisible: () => dispatch(toggleAlertPageIsVisible()),
  setAlertPageFirstBtnFunc: (x) => dispatch(setAlertPageFirstBtnFunc(x)),
  setAlertPageSecondBtnFunc: (x) => dispatch(setAlertPageSecondBtnFunc(x)),
  setAlertPageClean: (x) => dispatch(setAlertPageClean(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertPage);
